'use client';
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import HeroFeaturedStream from './HeroFeaturedStream';
import CountryFilterTabs from './CountryFilterTabs';
import LiveChannelsGrid from './LiveChannelsGrid';
import RadioStationsRow from './RadioStationsRow';
import LiveEventsSection from './LiveEventsSection';
import DashboardMetricsBar from './DashboardMetricsBar';
import SearchFilterBar from './SearchFilterBar';
import AdSpot from '@/components/AdSpot';

export default function StreamingDashboardClient() {
  const searchParams = useSearchParams();
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCountry, setActiveCountry] = useState('country-all');

  // Sync search query from URL params (set by Topbar search)
  useEffect(() => {
    const urlSearch = searchParams?.get('search') ?? '';
    setSearchQuery(urlSearch);
  }, [searchParams]);

  return (
    <div className="space-y-4 sm:space-y-6">
      <DashboardMetricsBar />

      {/* Ad spot above featured channel */}
      <AdSpot slot="1234567890" format="horizontal" className="w-full" />

      <HeroFeaturedStream />
      <SearchFilterBar
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />
      <section id="countries">
        <CountryFilterTabs
          activeCountry={activeCountry}
          onCountryChange={setActiveCountry}
        />
      </section>
      <section id="live-now">
        <LiveChannelsGrid
          searchQuery={searchQuery}
          activeCountry={activeCountry}
        />
      </section>
      <section id="radio">
        <RadioStationsRow searchQuery={searchQuery} />
      </section>
      <section id="events">
        <LiveEventsSection searchQuery={searchQuery} />
      </section>
    </div>
  );
}
